module.exports = {"failed":"認証情報が当社の記録と一致しません。","throttle":"ログイン試行回数が制限値を超えました。:seconds秒後にもう一度お試しください。"};